module.exports = __webpack_public_path__ + "static/media/align-bottom.58f61665.svg";